"use client";

import { cn, Icon } from "@kyan/ui";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { routes } from "#/config/routes";
import { useUserScopes } from "#/services/dynamic/hooks/useUserScopes";

export const navbarItems = (hasEarlyAccessVip: boolean) => {
  return [
    { label: "Options", path: routes.options() },
    { label: "Perps", path: routes.perps },
    { label: "Combo", path: routes.combo },
    ...(hasEarlyAccessVip
      ? [{ label: "Institutional", path: routes.institutional.index }]
      : []),
    {
      component: (isActive: boolean) => (
        <Icon
          name="surprise"
          hoverEffect="circle"
          className={cn({
            "hover:bg-primary/10 hover:text-primary": !isActive,
            "text-primary bg-transparent hover:bg-transparent": isActive,
          })}
        />
      ),
      path: routes.rewards.index,
    },
  ];
};

export const Navbar: React.FC = () => {
  const pathname = usePathname();
  const { hasEarlyAccessVip } = useUserScopes();

  const isRouteActive = (path: string) =>
    (path === routes.options() && path === pathname) ||
    (path !== routes.options() && pathname.startsWith(path));

  return (
    <nav className="flex h-full items-center">
      {navbarItems(hasEarlyAccessVip).map(({ label, component, path }) => {
        const isActive = isRouteActive(path as string);

        return (
          <Link
            key={path}
            href={path}
            className={cn(
              "group flex h-full items-center border-b border-transparent px-4 transition-colors",
              {
                "border-primary": isActive,
                "hover:text-textPrimary": !isActive && label,
                "text-textPrimary": isActive && label,
              },
            )}
          >
            {label ?? component(isActive)}
          </Link>
        );
      })}
    </nav>
  );
};
